import { CanActivateFn, Router } from '@angular/router';
import { Business } from '@reshiftdev/franify-assets-library';

export const postingGuard: CanActivateFn = () => {
  const router: Router = new Router();

  const businesses: Business[] = JSON.parse(
    localStorage.getItem('businesses') || '[]',
  );
  const businessId: string | null = localStorage.getItem('business_id');

  const currentBusiness: Business | undefined = businesses.find(
    (business) => business.business_id === businessId,
  );

  if (currentBusiness) {
    return currentBusiness.services?.posting
      ? true
      : router.createUrlTree(['/admin']);
  } else {
    return router.createUrlTree(['/admin']);
  }
};
